function getAnnotedFragments(notation, annotations) {
  return Object.keys(annotations).filter((frag) =>
    annotations[frag].includes(notation)
  );
}

export default getAnnotedFragments;
